import React, { useState, Fragment } from "react";
import { Button, H4, Intent } from "@blueprintjs/core";
import FadeIn from "react-fade-in";
import { DialogAddDropdownQuestion } from "./DialogAddDropdownQuestion";

export interface TNewDropdownQuestion {
  id: string;
  question: string;
  options: string[];
}

interface TQuestion {
  id: string;
  question: string;
  possibleAnswers: {
    id: string;
    answer: string;
  }[];
}

const PersonalData = ({
  hasBeenPlayed,
  addPersonalQuestion,
  personalQuestions,
  handleRemovePersonalQuestion,
}: {
  hasBeenPlayed: boolean;
  addPersonalQuestion: (question: TNewDropdownQuestion) => void;
  personalQuestions?: TNewDropdownQuestion[];
  handleRemovePersonalQuestion: (id: string) => void;
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const toggleDialog = () => {
    setIsDialogOpen(!isDialogOpen);
  };

  return (
    <Fragment>
      <div className="text-right">
        <Button
          intent={Intent.PRIMARY}
          rightIcon="add"
          text="Add Personal Question"
          style={{ marginBottom: "20px" }}
          onClick={toggleDialog}
          disabled={hasBeenPlayed}
        />
      </div>
      <FadeIn className="askPerso">
        <br />
        {hasBeenPlayed && (
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            You can't add personal questions as the session has already been
            played
          </div>
        )}
        {personalQuestions?.length &&
          personalQuestions.map((question) => (
            <div
              key={question.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <div>
                <H4>{question.question}</H4>
                <p>{question.options.map((answer) => answer).join(", ")}</p>
              </div>
              <Button
                icon="trash"
                intent={Intent.DANGER}
                minimal
                onClick={() => handleRemovePersonalQuestion(question.id)}
                disabled={hasBeenPlayed}
              />
            </div>
          ))}
      </FadeIn>
      <DialogAddDropdownQuestion
        isDialogOpen={isDialogOpen}
        toggleDialog={toggleDialog}
        addPersonalQuestion={addPersonalQuestion}
      />
    </Fragment>
  );
};

export default PersonalData;
